(function () {
  "use strict";

  const getDisplayRowIndex = require("./vm-helpers/getDisplayRowIndex");
  const getImportDataRows = require("./vm-helpers/getImportDataRows");
  const { getRowsToGeocode, getRowsNotToGeocode } = require("./vm-helpers/getRowsGeocodeHelper");

  angular
    .module("alk.import")
    .controller("importFieldsModalController", importFieldsModalController);

  importFieldsModalController.$inject = ["$scope", "$uibModalInstance", "alkImportService", "$translate", "alkModalService", "$filter", "$timeout",
    "$q", "PCMRegion", "UserProvider", "$http","data","alkGeocodeService"];

  function importFieldsModalController($scope, $uibModalInstance, alkImportService, $translate, alkModalService, $filter, $timeout,
    $q, PCMRegion, UserProvider, $http,data,alkGeocodeService) {
    var vm = this; 
    vm.submitForm = submitForm;
    vm.validate = validate;
    vm.cancel = cancel;
    vm.back = back;
    vm.firstFiveValuesStr = firstFiveValuesStr;
    vm.getDefaultFieldLabel = getDefaultFieldLabel;
    vm.canSubmit = canSubmit;
    vm.getSubmitButtonText = getSubmitButtonText;
    vm.getDisplayErrors = getDisplayErrors;
    vm.alignColumnLayout = alignColumnLayout;
    vm.getHeaders = getHeaders;
    vm.isLatLonSpecified = isLatLonSpecified;
   
    vm.isHistoricalDataVersion = data ? data.checkHistoricalVersion :true;

    var currentWizardData = alkModalService.getCurrentWizardData();
    var importFeatureType = currentWizardData.importFeatureType;
    vm.isPlacesImport = (importFeatureType === "ContentToolsPlaces");
    vm.isExceptionsImport = (importFeatureType === "ContentToolsExceptions");
    vm.isStopsImport = (importFeatureType === "PCMWebUIStops");

    vm.errors = [];
    vm.submitError = "";
    vm.submitted = false;
    vm.geocodeSubmitted = false;
    vm.importCols = [];
    vm.progressPercent = 0;
    vm.progressMessage = "";

    if (vm.isPlacesImport) {
      vm.fields = [
        alkImportService.PlaceNameField,
        alkImportService.CompanyIdField,
        alkImportService.LatitudeField,
        alkImportService.LongitudeField,
        alkImportService.LatLonField,
        alkImportService.StreetAddressField,
        alkImportService.CityField,
        alkImportService.StateField,
        alkImportService.CountryAbbrevField,
        alkImportService.ZipField,
        alkImportService.PhoneField,
        alkImportService.CountryField,
        alkImportService.CommentsField,
        alkImportService.YardNameField,
        alkImportService.YardPointsField,
        alkImportService.GatesField,
        alkImportService.EntryLatLonField,
        alkImportService.EntryLatLonSnapField,
        alkImportService.EntryNotesField,
        alkImportService.ExitLatLonField,
        alkImportService.ExitLatLonSnapField,
        alkImportService.ExitNotesField,
        alkImportService.SiteDetailField
      ];
      alkImportService.StateField.setRegion();
      alkImportService.CountryAbbrevField.setRegion();
    } else if (vm.isStopsImport) {
      vm.fields = [
        alkImportService.StopNameField,
        alkImportService.LatitudeField,
        alkImportService.LongitudeField,
        alkImportService.LatLonField,
        alkImportService.StreetAddressField,
        alkImportService.CityField,
        alkImportService.StateField,
        alkImportService.ZipField,
        alkImportService.CountryField,
        alkImportService.EstimatedDurationField,
        //alkImportService.EarliestArrivalTimeField,
        //alkImportService.LatestArrivalTimFielde
      ];
      // TODO pchen: add `alkImportService.StateField.setRegion();`?
    }
    vm.importRows = []; //Array of array of strings representing the import rows/columns parsed
    vm.headers = [];  //Array of import fields that represent the headers
    vm.headerChecked = false; //Is the header included as part of the first row? (Set by import fields UI)

    vm.importFunction = currentWizardData.importFunction;

    //By default, don't tick header checkbox if there's only one row, or there will be no data
    if (currentWizardData.headerChecked !== undefined) {
      vm.headerChecked = currentWizardData.headerChecked;
    } else if (currentWizardData.importRows && currentWizardData.importRows.length > 1) {
      vm.headerChecked = true;
    } else {
      vm.headerChecked = false;
    }

    init();

    ////////////////

    function init() {
      //Assign headers: Try to guess the field to assign
      if (currentWizardData.headers) {
        vm.headers = currentWizardData.headers;
      } else {
        vm.headers = getHeaders(currentWizardData.importRows[0]);
      }
      vm.importRows = currentWizardData.importRows;

      //Create the columns
      for (let i = 0; i < currentWizardData.importRows[0].length; i++) {
        vm.importCols[i] = [];
      }
      for (let i = 0; i < currentWizardData.importRows.length; i++) {
        for (var j = 0; j < currentWizardData.importRows[i].length; j++) {
          vm.importCols[j].push(currentWizardData.importRows[i][j]);
        }
      }

      //Validate on load
      vm.validate();

      alignColumnLayout();
    }

    function alignColumnLayout() {
      $timeout(function () {
        //Hack to set the select model on load (issues for some reason)
        for (var i = 0; i < vm.headers.length; i++) {
          $("#importFieldSelect" + i).val(vm.headers[i]);
        }
        //Adjust width of third column to fit to modal bounds. CSS has issues here for some reason (maybe due to table in a $uibmodal)?
        var tableWidth = $("#fieldSetId").outerWidth();
        var firstColWidth = $(".fieldHeaderCol").outerWidth();
        var secondColWidth = $(".fieldValueCol").outerWidth();
        $(".firstFiveCol").width(tableWidth - firstColWidth - secondColWidth);
      });
    }

    function showError(errorMessage) {
      vm.submitError = errorMessage;
      vm.submitted = false;
      vm.geocodeSubmitted = false;
    }

    function submitForm() {
      if (!vm.canSubmit()) return;
     
      vm.submitError = "";

      validateCIDsNewBeforeSubmit().then(function() {
        var rowsGeocoded = getRowsToGeocode(vm, $translate);
        // var addresses = getAddresses(rowsGeocoded);
        var rowsNotGeocoded = getRowsNotToGeocode(vm, $translate);

        //Save these fields for next modal
        currentWizardData.headerChecked = vm.headerChecked;
        currentWizardData.headers = vm.headers;

        //Create the import entities directly. Finishes the wizard.
        if (rowsGeocoded.length === 0) {
          //Save these fields for back button from next modal
          currentWizardData.geocodeResults = [];
          currentWizardData.inputRowsNotGeocoded = rowsNotGeocoded;
          //Save these fields for next modal
          currentWizardData.inputRowsToCreate = rowsNotGeocoded.slice();

          $uibModalInstance.close({
            wasGeocoded: false
          });
        }
        //Do a batch geocode first
        else {

          vm.geocodeSubmitted = true;
          vm.progressPercent = 0;
          vm.progressMessage = "";

          var progressCallback = function (numCompleted, numTotal) {
            var progStr = Math.floor(100 * numCompleted / numTotal);
            vm.progressMessage = $translate.instant("common.import.geocodingProgessBar", {
              progressString: progStr
            });
            vm.progressPercent = progStr;
          };
          getAddresses(rowsGeocoded).then(function(addresses){
          alkImportService.batchGeocodeAddresses(addresses, progressCallback)
            .then(function (responses) {
            //Error
              if (!responses) {
                showError($translate.instant("common.import.unknownError"));
                return;
              }

              for (let i = 0; i < responses.length; i++) {
                var response = responses[i];
                var rowObj = rowsGeocoded[i];

                response.inputRow = rowObj;

                //Give the response object the corresponding address string
                response.requestAddressStr = $filter("fullAddressFilter")({
                  StreetAddress: rowObj.StreetAddress,
                  City: rowObj.City,
                  State: rowObj.State,
                  Zip: rowObj.Zip,
                  County: rowObj.County,
                  Country: (rowObj.Country) ? rowObj.Country : rowObj.CountryAbbreviation
                },
                false
                );

                response.requestAddressStr = String(response.requestAddressStr);
              }

              //Save these fields for next modal
              currentWizardData.geocodeResults = responses;
              currentWizardData.inputRowsNotGeocoded = rowsNotGeocoded;

              $uibModalInstance.close({
                wasGeocoded: true
              });

            });
          });
        }
      });
      vm.submitted = true; //Prevent double click from submitting twice
    }

    function validateCIDsNewBeforeSubmit() {
      var deferred = $q.defer();

      // abort import if any CID to import is already found in the user's
      //  account in DataAnywhere
      var importRowsToSubmit = getImportDataRows(vm);
      var companyIdIndex = vm.headers.indexOf("CompanyId");
      if (companyIdIndex === -1) {
        deferred.resolve();
        return deferred.promise;
      }
      var uniqueCIDs = _.chain(importRowsToSubmit)
        .map( row => row[companyIdIndex] )
        .filter( cid => cid.length > 0 )
        .uniq().value();
      if (uniqueCIDs.length === 0) {
        deferred.resolve()
        return deferred.promise;
      }
      alkImportService.testCompanyIds(uniqueCIDs).then(
        function (conflictList) {
          if (!conflictList) {
            showError($translate.instant("common.import.unknownError"));
          } else if (conflictList.length > 0) {
            showError($translate.instant("common.import.companyIdConflictDetected", {
              cids: conflictList.join(", ")
            }));
            deferred.reject();
          } else {
            deferred.resolve();
          }
        });
      return deferred.promise;
    }

    function validate() {
      vm.errors = [];
      vm.submitError = "";

      //Verify that a certain required combination of fields was selected as fields
      if (!hasSufficientFieldsSelected()) {
        vm.errors.push($translate.instant("common.import.fieldErrNotEnoughFields"));
      } else  {
        //Verify that a certain required combination of fields was not set to blank for all fields in a particular row
        var blankComboErrs = validateSufficientFieldsSet();
        vm.errors = vm.errors.concat(blankComboErrs);
      }

      //Verify that the same field (besides "skip") was not selected twice
      if (duplicateHeaders()) {
        vm.errors.push($translate.instant("common.import.fieldErrDuplicateHeaders"));
      }

      //Verify no field was selected without its dependencies also selected
      var dependencyErrs = missingHeaderDependencies();
      vm.errors = vm.errors.concat(dependencyErrs);

      //Validate all fields
      var fieldErrs = validateRows();
      vm.errors = vm.errors.concat(fieldErrs);

      if(vm.isPlacesImport) {
        var companyIdConflicts = validateCIDsUnique();
        vm.errors = vm.errors.concat(companyIdConflicts);

        var placeNotInSiteErrs = validatePlaceInSiteShape();
        vm.errors = vm.errors.concat(placeNotInSiteErrs);

        var gateNotInSiteErrs = validateGateInSiteShape();
        vm.errors = vm.errors.concat(gateNotInSiteErrs);

        var insufficientGatesErrs = validateSufficientGates();
        vm.errors = vm.errors.concat(insufficientGatesErrs);
      }

    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function back() {
      //Clear out this data when going back so it doesn't persist when user changes file
      currentWizardData.headers = undefined;
      currentWizardData.headerChecked = undefined;

      $uibModalInstance.close({
        back: true
      });
    }

    //This helper function gets the display text of the first 5 values found for a field in the CSV
    function firstFiveValuesStr(col, headerChecked) {
      var retStr = "";
      var start = 0;
      var end = 5;
      if (headerChecked) {
        start += 1;
        end += 1;
      }
      for (var i = start; i < col.length && i < end; i++) {
        if (i > start) {
          retStr += ", ";
        }
        retStr += col[i];
      }
      if (col.length > end) {
        retStr += "...";
      }
      return retStr;
    }

    function getDefaultFieldLabel(index) {
      return $translate.instant("common.import.defaultFieldLabel") + " " + (index + 1).toString();
    }

    function canSubmit() {
      return vm.errors.length === 0 && !vm.submitted;
    }

    function getSubmitButtonText() {
      if (!vm.submitted) {
        return $translate.instant("common.Continue");
      } else {
        return $translate.instant("common.import.geocoding");
      }
    }

    function getDisplayErrors() {
      return alkImportService.filterErrors(vm.errors); //Hide rest of errors if over 100 AND 50 more will be hidden
    }

    //Given an array of headerVals, return a string of inferred field names
    //i.e. ["name", "lat", "lon"] gives ["PlaceName", "Latitude", "Longitude"]
    function getHeaders(headerVals) {
      var headers = [];
      var headersUsed = {};
      for(var headerVal of headerVals) {
        headerVal = headerVal.toLowerCase();
        var found = _.some(vm.fields, function (field) {
          if (!headersUsed[field.name] && field.suitableHeader(headerVal)) {
            headersUsed[field.name] = true;
            headers.push(field.name);
            return true;
          }
        });
        if (!found) {
          headers.push("Skip");
        }
      }
      return headers;
    }

    //Must have enough geocode info selected as header fields
    function hasSufficientFieldsSelected() {
      var sufficientCombos = [
        [alkImportService.LatitudeField, alkImportService.LongitudeField],
        [ alkImportService.LatLonField ],
        [alkImportService.CityField, alkImportService.StateField],
        [alkImportService.CityField, alkImportService.CountryAbbrevField],
        [alkImportService.CityField, alkImportService.CountryField],
        [ alkImportService.ZipField ]
      ];
      var headerCounts = _.countBy(vm.headers);
      for (var i = 0; i < sufficientCombos.length; i++) {
        var combo = sufficientCombos[i];
        var missingField = false;
        for (var j = 0; j < combo.length; j++) {
          var field = combo[j];
          if (!headerCounts[field.name]) {
            missingField = true;
            break;
          }
        }
        //All it takes is one required group fullfilled to have sufficient fields selected
        if (!missingField) {
          return true;
        }
      }
      return false;
    }

    // SWPWEB-1306
    function hasAddress() {
      var headerCounts = _.countBy(vm.headers);
       if((headerCounts.City && headerCounts.State) ||  headerCounts.Zip) // all address fields skipped
        return true;
      return false;
    }
    function hasLatLon() {
      var headerCounts = _.countBy(vm.headers);
      if((!headerCounts.Latitude && !headerCounts.Longitude) &&  !headerCounts.LatLon) 
        return false;
      return true;
    }


    //Return all errors where a row has invalid values (uses ImportField class methods to validate)
    function validateRows() {
      var fieldAtCol = getHeaderObjects();
      var rows = getImportDataRows(vm);
      var errs = [];
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        for (var j = 0; j < row.length; j++) {
          var val = row[j];
          var field = fieldAtCol[j];
          if(!field) continue;

          var fieldErrors = getFieldErrors(field, val, {
            row: getDisplayRowIndex(i, vm),
            col: String(j + 1),
            fieldName: field.getTranslatedName(),
            maxLength: field.maxLength
          });
          for(var error of fieldErrors) {
            errs.push(error);
          }
        }
      }
      return errs;
    }

    function getFieldErrors(field, fieldValue, fieldParams) {
      if(fieldValue.length > field.maxLength) {
        return [ $translate.instant("common.import.fieldErrTooLong", fieldParams) ];
      }
      return field.getErrors(fieldValue, fieldParams);
    }

    //Return all row errors where a required geocoding combination of fields were all set to blank
    //Currently, the geocoder expects either city+state, or zip
    //Sample error returned:
    //[ "Insufficient address values at row 1 (must provide non-empty city and state, or non-empty zip code)",
    // "Insufficient address values at row 2 (must provide non-empty city and state, or non-empty zip code)",
    // "(6 more occurrances of insufficient address values...)" ]
    function validateSufficientFieldsSet() {

      const insuffFieldsErrs = [];

      const latIndex = vm.headers.indexOf("Latitude");
      const lonIndex = vm.headers.indexOf("Longitude");
      const latLonIndex = vm.headers.indexOf("LatLon");
      const cityIndex = vm.headers.indexOf("City");
      const stateIndex = vm.headers.indexOf("State");
      const zipIndex = vm.headers.indexOf("Zip");

      const importRowsToSubmit = getImportDataRows(vm);
      for (let i = 0; i < importRowsToSubmit.length; i++) {
        let hasLat = false;
        let hasLon = false;
        let hasCity = false;
        let hasState = false;
        let hasZip = false;
        let hasNullLat = false;
        let hasNullLon = false;
        for (let j = 0; j < importRowsToSubmit[i].length; j++) {
          if (importRowsToSubmit[i][j]) {
            if (j === cityIndex) {
              hasCity = true;
            } else if (j === stateIndex) {
              hasState = true;
            } else if (j === zipIndex) {
              hasZip = true;
            } else if (j === latIndex) {
              hasLat = true;
              hasNullLat = parseFloat(importRowsToSubmit[i][j]) === 0;
            } else if (j === lonIndex) {
              hasLon = true;
              hasNullLon = parseFloat(importRowsToSubmit[i][j]) === 0;
            } else if (j === latLonIndex) {
              hasLat = true;
              if (importRowsToSubmit[i][j].indexOf(",") !== -1) {
                hasLon = true;
                const [lat, lon] = importRowsToSubmit[i][j].split(",");
                hasNullLat = parseFloat(lat) === 0;
                hasNullLon = parseFloat(lon) === 0;
              }
            }
          }
        }
        if (hasLat && hasLon && hasNullLat && hasNullLon) {
          // 0,0 aka null latlon
          hasLat = false;
          hasLon = false;
        }
        if (!((hasCity && hasState) || (hasLat && hasLon) || hasZip)) {
          insuffFieldsErrs.push($translate.instant("common.import.fieldErrInsufficientFields", {
            row: getDisplayRowIndex(i, vm)
          }));
        }
      }

      return insuffFieldsErrs;
    }

    //Get an array of header objects (vm.headers just has the string keys)
    function getHeaderObjects() {
      var headerObjectArray = [];
      for(var headerString of vm.headers) {
        var headerObj = _.find(vm.fields, function (field) {
          return field.name === headerString;
        });
        headerObjectArray.push(headerObj);
      }
      return headerObjectArray;
    }

    //Return true if duplicate headers, i.e. ["Name", "Name"]
    function duplicateHeaders() {
      const headerCounts = _.countBy(vm.headers);
      const hasSimpleDuplicate = _.some(vm.fields, field => (headerCounts[field.name] > 1));
      // latitude + longitude is semantically identical to latlon
      const hasLat = vm.headers.indexOf("Latitude") !== -1;
      const hasLon = vm.headers.indexOf("Longitude") !== -1;
      const hasLatLon = vm.headers.indexOf("LatLon") !== -1;
      return hasSimpleDuplicate || ((hasLat || hasLon) && hasLatLon);
    }

    function missingHeaderDependencies() {
      const errs = [];
      for (let header of getHeaderObjects()) {
        if (!header)
          // undefined = 'Skip'
          continue;
        for (let dependency of header.dependencies) {
          if (vm.headers.indexOf(dependency.name) === -1) {
            errs.push($translate.instant("common.import.fieldErrMissingDependency", {
              fieldName: header.getTranslatedNameTitleCase(),
              dependencyName: dependency.getTranslatedNameTitleCase()
            }));
          }
        }
      }
      return errs;
    }

    //Get addresses from list of row objects
    function getAddresses(rows) {
      var deferred = $q.defer();
      var addresses = [];
      if(hasLatLon()){
        var total = rows.length;
        var promises=[];
        for (let i = 0; i < total; i++) {
          promises.push(geocodingPromises(rows[i]));
      
    }
    $q.all(promises).then(function (response) {
      console.log(response);
      deferred.resolve(response);
      return response;

    });
  }else{
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var address = {};
        address.StreetAddress = row.StreetAddress;
        address.City = row.City;
        address.State = row.State;
        address.Zip = row.Zip;
        address.County = row.County;
        address.CountryAbbreviation = row.CountryAbbreviation;
        address.Country = row.Country;
        address.AbbreviationFormat = 1; // ISO2
        addresses.push(address);
       
      }
      deferred.resolve(addresses);
      }
     
    return deferred.promise;
    }
    function geocodingPromises(row){
    
    var deferred = $q.defer();
    alkGeocodeService.reverseGeocode({
      "lat": row.Latitude,
      "lon": row.Longitude
    }, {
      region: UserProvider.getUser().region,
      dataset: UserProvider.getUser().dataset
    })
    .then((resp) => {
      
      console.log(resp);
      var address = {};
      address.StreetAddress = resp[0].Address.StreetAddress;
      address.City = resp[0].Address.City;
      address.State = resp[0].Address.State;
      address.Zip = resp[0].Address.Zip;
      address.County = resp[0].Address.County;
      address.CountryAbbreviation = resp[0].Address.CountryAbbreviation;
      address.Country = resp[0].Address.Country;
      address.AbbreviationFormat = 1; 
     
      deferred.resolve(address);
        });
  return deferred.promise;
}
    //Only true if lat/lon is specified and an address field isn't.
    function isLatLonSpecified() {
      var headerCounts = _.countBy(vm.headers);
      if (headerCounts.Latitude >= 1 && headerCounts.Longitude >= 1 || headerCounts.LatLon >= 1) {
        if ((headerCounts.City >= 1 && headerCounts.State >= 1) || headerCounts.Zip >= 1) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    }

    //Return all row errors of duplicate Company Ids in import
    function validateCIDsUnique() {
      var errs = [];
      var importRowsToSubmit = getImportDataRows(vm);
      var companyIdIndex = vm.headers.indexOf("CompanyId");
      if (companyIdIndex === -1)
        return [];
      // storing into variable to preserve rowIndex, CID pairs
      var cids = _.map(importRowsToSubmit, function (row) {
        return row[companyIdIndex];
      });
      var duplicateCIDs = _.chain(_.range(0, cids.length))
        .groupBy( i => cids[i] )
        // note: should change to pickBy for lodash 4.0.0+
        .pick( occurrences => occurrences.length > 1 )
        .value();
      // multiple places without Company Ids should not count as a conflict
      delete duplicateCIDs[""];
      _.each(duplicateCIDs, function (rowNums, cid) {
        errs.push($translate.instant("templates.importPlaces.fieldErrDuplicateCID", {
          cid: cid,
          rows: _.map(rowNums, i => getDisplayRowIndex(i, vm)).join(", ")
        }));
      });
      return errs;
    }

    //Return all row errors where a place was not in a site shape
    function validatePlaceInSiteShape() {
      var errs = [];
      var importRowsToSubmit = getImportDataRows(vm);
      for (var i = 0; i < importRowsToSubmit.length; i++) {
        var row = importRowsToSubmit[i];
        if (!placeInSiteShape(row)) {
          errs.push($translate.instant("templates.importPlaces.fieldErrPlaceNotInSite", {
            row: getDisplayRowIndex(i, vm)
          }));
        }
      }
      return errs;
    }

    function placeInSiteShape(row) {
      const placeLatIndex = vm.headers.indexOf("Latitude");
      const placeLonIndex = vm.headers.indexOf("Longitude");
      const placeLatLonIndex = vm.headers.indexOf("LatLon");
      const yardCoordsIndex = vm.headers.indexOf("YardPoints");
      const hasPlace = (placeLatIndex !== -1 && placeLonIndex !== -1) || placeLatLonIndex !== -1;
      if (!hasPlace || yardCoordsIndex === -1) {
        return true;
      }

      let placeLat;
      let placeLon;
      if (placeLatLonIndex === -1) {
        placeLat = row[placeLatIndex];
        placeLon = row[placeLonIndex];
      } else {
        [placeLat, placeLon] = row[placeLatLonIndex].split(",");
      }

      if (alkImportService.strContainsLonLat(row[yardCoordsIndex], placeLon, placeLat)) {
        return true;
      }

      return false;
    }

    //Return all row errors where an entry or exit gate was not within site shape bounds
    function validateGateInSiteShape() {
      var errs = [];

      var yardCoordsIndex = vm.headers.indexOf("YardPoints");
      var gateCoordsIndex = vm.headers.indexOf("Gates");
      var entryGateCoordsIndex = vm.headers.indexOf("EntryLatLon");
      var exitGateCoordsIndex = vm.headers.indexOf("ExitLatLon");

      if (yardCoordsIndex === -1)
        return [];

      var importRowsToSubmit = getImportDataRows(vm);
      for (var i = 0; i < importRowsToSubmit.length; i++) {
        var row = importRowsToSubmit[i];
        var siteStr = row[yardCoordsIndex];
        var gatesString = row[gateCoordsIndex];
        var entryVal = row[entryGateCoordsIndex];
        var exitVal = row[exitGateCoordsIndex];

        // TODO pchen: consider taking this out and replacing it with more generic dependency check using BaseImportField#dependencies
        if (!siteStr && (gatesString || entryVal || exitVal))
          return [$translate.instant("templates.importPlaces.fieldErrGateButNoSite", {
            row: getDisplayRowIndex(i, vm)
          })];

        if(gatesString) {
          var gates = alkImportService.getGatesFromString(gatesString);
          for(var j = 0; j < gates.length; j++) {
            let gate = gates[j];
            if (!alkImportService.strContainsLonLat(row[yardCoordsIndex], gate.Coords.Lon, gate.Coords.Lat, true)) {
              errs.push($translate.instant("templates.importPlaces.fieldErrGateNotInSite", {
                gateNum: j+1,
                row: getDisplayRowIndex(i, vm)
              }));
            }
          }
        }

        if(entryVal) {
          var entryLatLon = alkImportService.getLatLonFromString(entryVal);
          if (!alkImportService.strContainsLonLat(row[yardCoordsIndex], entryLatLon.Lon, entryLatLon.Lat, true)) {
            errs.push($translate.instant("templates.importPlaces.fieldErrEntryGateNotInSite", {
              row: getDisplayRowIndex(i, vm)
            }));
          }
        }

        if(exitVal) {
          var exitLatLon = alkImportService.getLatLonFromString(exitVal);
          if (!alkImportService.strContainsLonLat(row[yardCoordsIndex], exitLatLon.Lon, exitLatLon.Lat, true)) {
            errs.push($translate.instant("templates.importPlaces.fieldErrExitGateNotInSite", {
              row: getDisplayRowIndex(i, vm)
            }));
          }
        }

      }

      return errs;
    }

    function validateSufficientGates() {
      const errs = [];

      const importRowsToSubmit = getImportDataRows(vm);
      const siteCoordsIndex = vm.headers.indexOf("YardPoints");
      const gateCoordsIndex = vm.headers.indexOf("Gates");
      const entryGateCoordsIndex = vm.headers.indexOf("EntryLatLon");
      const exitGateCoordsIndex = vm.headers.indexOf("ExitLatLon");

      //No site coords in header at all - there's no site to validate gates for the whole CSV
      if (siteCoordsIndex === -1) {
        return [];
      }

      for (let i = 0; i < importRowsToSubmit.length; i++) {
        const row = importRowsToSubmit[i];

        //A row does not have site coords set - skip this row
        if (!row[siteCoordsIndex]) {
          continue;
        }

        let hasGates = false;
        let hasEntry = false;
        let hasExit = false;
        const gatesString = row[gateCoordsIndex];
        if (gatesString) {
          const gates = alkImportService.getGatesFromString(gatesString);
          hasGates = Array.isArray(gates) && gates.length > 0;
          hasEntry = hasGates && _.some(gates, gate => gate.Type === 0 || gate.Type === 2);
          hasExit = hasGates && _.some(gates, gate => gate.Type === 1 || gate.Type === 2);
        }

        const entryVal = row[entryGateCoordsIndex];
        if (entryVal) {
          const entryLatLon = alkImportService.getLatLonFromString(entryVal);
          const entryLatLonSnap = alkImportService.getLatLonFromString(entryVal);
          if (entryLatLon && entryLatLonSnap) {
            hasGates = true;
            hasEntry = true;
          }
        }

        const exitVal = row[exitGateCoordsIndex];
        if (exitVal) {
          const exitLatLon = alkImportService.getLatLonFromString(exitVal);
          const exitLatLonSnap = alkImportService.getLatLonFromString(exitVal);
          if (exitLatLon && exitLatLonSnap) {
            hasGates = true;
            hasExit = true;
          }
        }

        if (hasGates && (!hasEntry || !hasExit)) {
          errs.push($translate.instant("templates.importPlaces.fieldErrInsufficientGates", {
            row: getDisplayRowIndex(i, vm)
          }));
        }
      }

      return errs;
    }

  }

})();





// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/importFieldsModal.controller.js